import { EventEmitter, OnInit, OnChanges } from '@angular/core';
var AppInfoBoxComponent = /** @class */ (function () {
    function AppInfoBoxComponent() {
        this.active = false;
        this.showNumber = '-';
        this.notify = new EventEmitter();
        this.tooltip = '';
    }
    AppInfoBoxComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(AppInfoBoxComponent.prototype, "isForJob", {
        get: function () {
            return this.label.toLowerCase().indexOf('job') > -1;
        },
        enumerable: true,
        configurable: true
    });
    AppInfoBoxComponent.prototype.ngOnChanges = function () {
        if (this.label.toLowerCase().indexOf('job') > -1) {
            this.icon = 'briefcase';
            this.tooltip = 'You have ' + (this.start_threshold ? 'used ' + this.start_threshold + ' of ' : '') + this.threshold +
                ' Job Offers available. For more information or to buy new ones, contact your dedicated consultant.';
        }
        if (this.label.toLowerCase().indexOf('event') > -1) {
            this.icon = 'briefcase';
            this.tooltip = 'Hai usato ' + this.start_threshold + ' delle ' + this.threshold +
                ' Job Offers disponibili. Per maggiori informazioni o per acquistarne di nuove, contatta il tuo consulente dedicato.';
        }
        if (this.label.toLowerCase().indexOf('articles') > -1) {
            this.icon = 'list';
            this.tooltip = 'Hai usato ' + this.start_threshold + ' dei ' + this.threshold +
                ' post disponibili. Per maggiori informazioni o per acquistarne di nuovi, contatta il tuo consulente dedicato.';
        }
        if (this.label.toLowerCase().indexOf('polls') > -1) {
            this.icon = 'tachometer-alt';
            this.tooltip = 'Hai usato ' + this.start_threshold + ' dei ' + this.threshold +
                ' poll disponibili. Per maggiori informazioni o per acquistarne di nuovi, contatta il tuo consulente dedicato.';
        }
        if (this.label.toLowerCase().indexOf('applications') > -1) {
            this.icon = 'file-alt';
        }
        if (this.label.toLowerCase().indexOf('views') > -1) {
            this.icon = 'eye';
        }
        if (this.label.toLowerCase().indexOf('impressions') > -1) {
            this.icon = 'bullseye';
        }
        if (this.label.toLowerCase().indexOf('answers') > -1) {
            this.icon = 'flag';
        }
        if (this.delta) {
            if (this.delta > 0) {
                this.delta_percentage = '+' + Math.floor((this.delta / Number(this.showNumber)) * 100) + '%';
            }
            if (this.delta < 0) {
                this.delta_percentage = '-' + Math.floor((this.delta / Number(this.showNumber)) * 100) + '%';
            }
        }
    };
    AppInfoBoxComponent.prototype.boxClicked = function () {
        if (this.clickable) {
            this.notify.emit(this.label);
        }
    };
    return AppInfoBoxComponent;
}());
export { AppInfoBoxComponent };
